import * as _ from "lodash";
import { useState, useEffect } from "react";
import World from "../world";
import { MaybeAPIErr } from "../api";

type UploadHook = {
    url: string;
    err: string;
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
    isPending: boolean;
}

function useUpload(world: World): UploadHook {
    const [url, setURL] = useState("");
    const [err, setErr] = useState("");
    const [isPending, setIsPending] = useState(false);

    const onChange = async (e: React.FormEvent<HTMLInputElement>) => {
        if (!e.currentTarget.files.length) {
            return;
        }
        const formData = new FormData();
        formData.append("file", e.currentTarget.files[0]);

        setIsPending(true);

        const [postURL, err] = await world.getUploadURL();
        if (err) {
            setIsPending(false);
            setErr(err.message);
            return;
        }

        const response = await fetch(postURL, {
            method: "POST",
            body: formData,
        });
        const body = await response.json();

        setIsPending(false);

        if (response.status >= 300 || !body.success || !body.result.variants.length) {
            // TODO report and show
            console.log(body);
            return;
        }

        setURL(body.result.variants[0]);
    };

    return {
        url,
        err,
        onChange,
        isPending,
    };
}

export default useUpload;
